import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import { UserEventHandler } from '@sendbird/chat';
import { useSendbirdStateContext } from '@sendbird/uikit-react';

const SendbirdUnreadContext = createContext(0);

export function useSendbirdUnreadCount() {
  return useContext(SendbirdUnreadContext);
}

/** Must render inside SendbirdProvider — syncs unread count for BaseMenu. */
export function SendbirdUnreadProvider({ children }: { children: ReactNode }) {
  const [unreadMessagesCount, setUnreadMessagesCount] = useState(0);
  const {
    stores: {
      sdkStore: { sdk },
    },
  } = useSendbirdStateContext();

  useEffect(() => {
    if (!sdk) {
      return;
    }

    const fetchInitialCount = async () => {
      if (!sdk.groupChannel) {
        return;
      }
      try {
        const count = await sdk.groupChannel.getTotalUnreadMessageCount();
        setUnreadMessagesCount(count);
      } catch (error) {
        console.error('Failed to fetch initial unread count:', error);
      }
    };
    fetchInitialCount();

    sdk.addUserEventHandler?.(
      'messagesCount',
      new UserEventHandler({
        onTotalUnreadMessageCountUpdated: (totalCount) => {
          setUnreadMessagesCount(totalCount);
        },
      })
    );
  }, [sdk]);

  return (
    <SendbirdUnreadContext.Provider value={unreadMessagesCount}>{children}</SendbirdUnreadContext.Provider>
  );
}

export function SendbirdUnreadFallback({ children }: { children: ReactNode }) {
  return <SendbirdUnreadContext.Provider value={0}>{children}</SendbirdUnreadContext.Provider>;
}
